
export const stageKPIs = [
    {name: 'Soma de valores', value: 'values_sum'},
    {name: 'Soma de contas (Pagar/Receber) ', value: 'bills_sum'},
];

export const optionFilter = [
    {name: 'Produto', value: 'produto'},
    {name: 'Vendedor', value: 'vendedor'},
    {name: 'Data Cadastro', value: 'data_cadastro'},
    // {name: 'Data Conclusão', value: 'data_conclusao'},
];

export const linesButtons = [
    {name: 'Calendário', value: 'agendar'},
    {name: 'Descartar', value: 'descartar'},
    {name: 'Dossiê', value: 'dossie'},
    {name: 'Remover Alerta', value: 'remover_alerta'},
    // {name: 'Qualificar', value: 'qualificar'},
    {name: 'Proposta', value: 'proposta'},
    {name: 'Gerar Contas', value: 'gerar_contas'},
    {name: 'Ordem de Serviço', value: 'ordem_servico'},
    {name: 'Ordem de Produção', value: 'ordem_producao'},
    {name: 'Romaneio de Produção', value: 'romaneio_producao'},
    {name: 'WhatsApp', value: 'whats_chat'},
    {name: 'Definir responsável', value: 'define_responsible'},
    {name: 'Etiqueta de envio', value: 'etiqueta_envio'},
    {name: 'Gerar venda', value: 'gerar_venda'},
    {name: 'Gerar cobrança', value: 'gerar_cobranca'},
    // {name: 'Visualizar Fatura', value: 'view_invoice'},
    {name: 'Finalizar', value: 'finalizar'},
    {name: 'Nota Fiscal', value: 'nota_fiscal'},
    {name: 'Nota Fiscal Consumidor', value: 'nota_fiscal_consumidor'},
    {name: 'Definir Prioridade', value: 'define_priority'},
    // {name: 'Nota Fiscal Serviço', value: 'nota_fiscal_servico'},
];

export const linesKPIs = [
    {label: 'Nome do Departamento', value: 'name_board'},
    {label: 'Filtro no Departamento', value: 'filter_board'},
    {label: 'Adicionar Ticket', value: 'add_ticket'},
    {label: 'Buscar', value: 'find_client'},
    // {label: 'Vendedor Online', value: 'vendedor_online'},
    {label: 'Total de Oportunidades', value: 'total_oportunidade'},
    // {label: 'Meta Atendimento', value: 'meta_individual_leads'},
    // {label: 'Meta Individual', value: 'meta_individual_vendas'},
    // {label: 'Meta Conversão', value: 'meta_conversao'},
    // {label: 'Ferramentas Comerciais', value: 'ferramentas_comerciais'},
    {label: 'Calendário', value: 'calendario'},
    // {label: 'Meta de Vendas', value: 'meta_vendas'},
    {label: 'Contas a Pagar', value: 'contas_pagar'},
    {label: 'Contas a Receber', value: 'contas_receber'},
    {label: 'Saúde Financeira', value: 'saude_financeira'},
    {label: 'Novos Cadastros Dia', value: 'novos_leads_dia'},
    {label: 'Novos Cadastros Semana', value: 'novos_leads_semana'},
    {label: 'Novos Cadastros Mês', value: 'novos_leads_mes'},
    {label: 'Pausar Atualização do Departamento', value: 'stop_refresh'},
    {label: 'Notificações Pessoais', value: 'personal_notifications'},
    {label: 'Nova Notificação pessoal', value: 'new_personal_notification'},
    {label: 'Mostrar atividades finalizadas', value: 'show_finished_tasks'},
];

export const allComponentsTemplate = [
    {id: 1, name: 'Bloco Pessoa', title: 'BlockPerson'},
    {id: 2, name: 'Bloco Pessoa Curta', title: 'BlockPersonSmall'},
    {id: 3, name: 'Bloco Anexos', title: 'BlockAttachments'},
    {id: 4, name: 'Bloco Contrato Assinado', title: 'BlockMainAttachments'},
    {id: 5, name: 'Bloco Itens', title: 'BlockItens'},
    {id: 6, name: 'Bloco Condições Comerciais', title: 'BlockCommercialConditions'},
    {id: 7, name: 'Bloco Contrato', title: 'BlockContract'},
    {id: 8, name: 'Bloco Ocorrências', title: 'BlockOccurrences'},
    {id: 9, name: 'Bloco Contas a Pagar/Receber', title: 'BlockBills'},
    {id: 10, name: 'Bloco Ordem de Serviço: Identificação', title: 'BlockOrderServiceHead'},
    {id: 11, name: 'Bloco Ordem de Serviço: Serviços com preço', title: 'BlockOrderServiceItensWithPrice'},
    {id: 12, name: 'Bloco Ordem de Serviço: Serviços sem preço', title: 'BlockOrderServiceItensWithoutPrice'},
    {id: 13, name: 'Bloco Ordem de Serviço: Controle de tempo', title: 'BlockOrderServiceTimeControl'},
    {id: 14, name: 'Bloco Ordem de Serviço/Produção: Tarefas e itens', title: 'BlockOrderServiceTasksAndItens'},
    {id: 15, name: 'Bloco Ordem de Serviço/Produção: Insumos necessários', title: 'BlockOrderServiceSupplies'},
    {id: 16, name: 'Bloco Informações adicionais', title: 'BlockAdditionalInformation'},
    // {id: 17, name: 'Bloco Aulas Agendadas', title: 'BlockClassSchedule'},
    // {id: 18, name: 'Bloco Cronograma de Aulas', title: 'BlockClassTimeline'},
    {id: 19, name: 'Bloco Veículo', title: 'BlockVehicle'},
    {id: 20, name: 'Bloco Endereço de Entrega', title: 'BlockAdditionalAddress'},
    {id: 21, name: 'Bloco Anexos de Engenharia', title: 'BlockEngineeringAttachments'},
    {id: 22, name: 'Bloco Anexos de Fabricação', title: 'BlockManufacturingAttachments'},
    {id: 23, name: 'Bloco Ordem de Serviço/Produção: Tarefas e itens (APENAS VISUALIZAÇÃO)', title: 'BlockOrderServiceTasksAndItensView'},
    {id: 24, name: 'Bloco Arquivos de Rede Interna', title: 'BlockNetworkFiles'},
];

export const allComponentsCardTemplate = [
    {id: 1, name: 'Nome', value: 'BlockName'},
    {id: 2, name: 'Telefone', value: 'BlockPhone'},
    {id: 3, name: 'Email', value: 'BlockEmail'},
    {id: 4, name: 'Endereço', value: 'BlockLocation'},
    {id: 5, name: 'Valor Orçamento', value: 'BlockInvoiceValue'},
    {id: 6, name: 'Tipo de conta', value: 'BlockBillType'},
    {id: 7, name: 'Valor da conta', value: 'BlockBillValue'},
    {id: 8, name: 'Valor da parcela aberta', value: 'BlockBillValueOpen'},
    {id: 9, name: 'Valor da parcela paga', value: 'BlockBillValueDown'},
    {id: 10, name: 'Valor da parcela vencida', value: 'BlockBillValueIssue'},
    {id: 11, name: 'Responsável do serviço', value: 'BlockSupplierService'},
    {id: 12, name: 'Responsável pelo serviço', value: 'BlockResponsibleService'},
    {id: 13, name: 'Previsão do serviço', value: 'BlockPrevisionService'},
    {id: 14, name: 'Solicitante do serviço', value: 'BlockResquesterService'},
    {id: 15, name: 'Número de controle da atividade', value: 'BlockControlNumber'},
    {id: 16, name: 'Tarefa principal da atividade', value: 'BlockOrderServiceTask'},
    {id: 17, name: 'Tipo do serviço da atividade', value: 'BlockOrderServiceType'},
    {id: 18, name: 'SKU do item principal das tarefas', value: 'BlockOrderServiceTaskItemSKU'},
    {id: 19, name: 'Percentual de tarefas concluídas', value: 'BlockTasksFinishedPorcent'},
    {id: 20, name: 'Tarefa principal da atividade com foto', value: 'BlockOrderServiceTaskPhoto'},
    {id: 21, name: 'Item principal da proposta comercial com foto', value: 'BlockMainProposalItemPhoto'},
    {id: 22, name: 'Informações adicionais da atividade', value: 'BlockAdditionalInfo'},
    // {id: 23, name: 'Título da atividade', value: 'BlockActivitySingleUse'},
];

export const Combustiveis = {
    Alcool:'Álcool',
    Biodiesel:'Biodiesel',
    Diesel:'Diesel',
    Etanol:'Etanol',
    Eletrico:'Energia Elétrica',
    Gasolina:'Gasolina',
    GNV:'GNV',
}